import { request } from '@/plugins/http';

/**
 * 账号列表
 * @param params
 * @returns {AxiosPromise}
 */
const getUserList = params => request('/user/getUserList', params);

/**
 * 账号启用禁用
 * @param params
 * @returns {AxiosPromise}
 */
const updateUsers = params => request('/user/updateUsers', params);

/**
 * 账号角色级联
 * @param params
 * @returns {AxiosPromise}
 */
const getUserRoleList = params => request('/role/getRoleList', params);

/**
 * 重置账号密码
 * @param params
 * @returns {AxiosPromise}
 */
const resetPasspord = params => request('/user/resetPasspord', params);

/**
 * 添加账号
 * @param params
 * @returns {AxiosPromise}
 */
const addUser = params => request('/user/addUser', params);

/**
 * 删除账号
 * @param params
 * @returns {AxiosPromise}
 */
const delUser = params => request('/user/delUser', params);

/**
 * 账号回显
 * @param params
 * @returns {AxiosPromise}
 */
const getUserDataEcho = params => request('/user/getUser', params);

/**
 * 修改账号
 * @param params
 * @returns {AxiosPromise}
 */
const updateUser = params => request('/user/updateUser', params);


export {
    getUserDataEcho,
    updateUser,
    addUser,
    delUser,
    getUserList,
    updateUsers,
    resetPasspord,
    getUserRoleList
};
